import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { AnyAction } from "redux";
import { IGLFiscalYearClose } from "./GLFiscalYearClose.types";
import { IStoreState } from "../../initialStoreState";
import { showMessage } from "../../messages/messagesActions";
import { api } from "../../../api/api";
import { translateBackendError } from "../../../helpers/errorTranslator";

export const FETCH_GL_FISCAL_YEAR_CLOSE_LIST_PROGRESS =
  "FETCH_GL_FISCAL_YEAR_CLOSE_LIST_PROGRESS";
export const FETCH_GL_FISCAL_YEAR_CLOSE_LIST_SUCCESS =
  "FETCH_GL_FISCAL_YEAR_CLOSE_LIST_SUCCESS";
export const FETCH_GL_FISCAL_YEAR_CLOSE_LIST_FAILED =
  "FETCH_GL_FISCAL_YEAR_CLOSE_LIST_FAILED";

export const fetchGLFiscalYearCloseListProgress = () =>
  action(FETCH_GL_FISCAL_YEAR_CLOSE_LIST_PROGRESS);
export const fetchGLFiscalYearCloseListSuccess = (
  data: IGLFiscalYearClose[],
  totalRecords: number,
) => action(FETCH_GL_FISCAL_YEAR_CLOSE_LIST_SUCCESS, { data, totalRecords });
export const fetchGLFiscalYearCloseListFailed = () =>
  action(FETCH_GL_FISCAL_YEAR_CLOSE_LIST_FAILED);

interface IFetchGLFiscalYearCloseListParams {
  fiscal_years_code?: string;
  pageNo: number;
  itemPerPage: number;
}

export const fetchGLFiscalYearCloseListAsync =
  ({
    fiscal_years_code,
    pageNo,
    itemPerPage,
  }: IFetchGLFiscalYearCloseListParams): ThunkAction<
    void,
    IStoreState,
    {},
    AnyAction
  > =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchGLFiscalYearCloseListProgress());

      let finalUrl = `/accounting/gl-fiscal-year-close?pageNo=${pageNo}&itemPerPage=${itemPerPage}`;
      if (fiscal_years_code) {
        finalUrl += `&fiscal_years_code=${fiscal_years_code}`;
      }

      const res = await api.get(finalUrl);
      const data: IGLFiscalYearClose[] = res.data.data;
      dispatch(
        fetchGLFiscalYearCloseListSuccess(data, res.data.totalRecords),
      );
    } catch (err: any) {
      dispatch(fetchGLFiscalYearCloseListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: translateBackendError(err.response?.data),
          displayAs: "snackbar",
        }),
      );
    }
  };

export const CLEAR_GL_FISCAL_YEAR_CLOSE_STATE =
  "CLEAR_GL_FISCAL_YEAR_CLOSE_STATE";
export const clearGLFiscalYearCloseState = () =>
  action(CLEAR_GL_FISCAL_YEAR_CLOSE_STATE);
